import { render } from "./NewPass.vue?vue&type=template&id=359df1a0"
import script from "./NewPass.vue?vue&type=script&lang=js"
export * from "./NewPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__